import {CORE,counts} from './engine.mjs';
import {budgetOf,VERSION} from './questions.mjs';
export function createSession(){return {version:VERSION,createdAt:Date.now(),answers:{},history:[],contexts:{},revision:0};}
// Previous answer codes and budgets remain compatible. New clarifications do not reset the allowance.
export function upgradeSession(saved){
 if(!saved||![VERSION,'0.22.0','0.23.0','0.24.0','0.25.0','0.26.0','0.27.0','0.28.0'].includes(saved.version)||!saved.answers||!Array.isArray(saved.history))return null;
 return {...structuredClone(saved),version:VERSION};
}
export function validateAnswer(q,v,answers={}){
 if(q.id==='C04'){
  if(answers.C03==='E')return ['Y','N','P'].includes(v)?null:'Choose one answer.';
  if(['UNSET','DECLINED'].includes(v))return null;
  const variant=q.variants?.find(x=>x.when.equals===answers.C03);
  if(v?.kind!=='AMOUNT'||!variant||v.basis!==variant.basis)return 'Review the target and its meaning.';
  const s=String(v.value);if(!/^\d{1,15}(\.\d{1,2})?$/.test(s))return 'Enter an amount of £0 or more, or choose one of the other answers.';
  return null;
 }
 if(q.component==='short_text')return typeof v==='string'&&v.trim().length>0&&v.length<=280?null:'Describe one limit in up to 280 characters.';
 const values=Array.isArray(v)?v:[v];
 if(!values.length||values.some(x=>!q.options.some(o=>o.id===x)))return q.component==='multiple_choice'?'Choose at least one answer.':'Choose one answer.';
 if(q.component!=='multiple_choice'&&Array.isArray(v))return 'Choose one answer.';
 if(new Set(values).size!==values.length)return 'Choose each answer only once.';
 if(values.length>1&&values.some(x=>q.selection?.exclusive.includes(x)))return 'Choose an exclusive answer on its own.';
 return null;
}
const dependencies={
 C03:['C04','C05','D01-GOAL','D02-PF','D02-RS','D02-BR','D02-WORK','D02-SC','D02-CD'],
 'D01-GOAL':['D02-PF','D02-RS','D02-BR','D02-WORK','D02-SC','D02-CD'],C04:['C05'],C14:['B24','B05','B06'],C15:['B24','B14-OWN','B14-HOURS','B14-BORROW','B14-GUARANTEE','B14-CONTROL','D01-BOUNDARY'],
 B24:['B23','B16','B22','B04','B05','B08','B09','B15','PF04','D02-BH','D02-SH','D02-PF','D02-RS','D02-BR','D02-WORK','D02-SC','D02-CD'],
 C16:['B23','B16','B22','B04','B05','B08','B09','D02-BH','D02-SH','D02-PF','D02-RS','D02-BR','D02-WORK','D02-SC','D02-CD'],
 C09:['B02','PF04'],C06:['B03'],C20:['D01-BRIDGE'],
 B23:['B16','B22','D02-RS','D02-BH','D02-SH','D02-BR','B04','B05','D02-WORK','D02-SC','D02-CD'],RT02:['RF01'],RT03:['RF03'],RT05:['RF04'],B16:['D02-RS','D02-BR','D02-BH','B22'],
 'D02-BR':['B22','D02-BH','B09','D02-WORK','D02-SH','D02-CD'],
 'D02-BH':['D02-BR','D02-SH','D02-WORK','D02-CD','B08','B09'],'D02-RS':['D02-BH','D02-BR','D02-CD'],
 // A changed work comparison makes the follow-ups chosen from it stale; the spent allowance is not refunded.
 'D02-WORK':['D02-BR','D02-BH','D02-SH','D02-CD','B08','B09','B05','B16','B22','D02-RS'],'D02-PF':['B15','B23','B16','B22','D02-WORK','D02-SC','D02-CD'],'D02-SC':['D02-CD','B16','B04','B05']
};
export function editAnswer(session,id,value){
 const n=structuredClone(session),different=JSON.stringify(n.answers[id])!==JSON.stringify(value);
 if(different&&Object.hasOwn(n.answers,id)){
  const sameTransferableRole=id==='C16'&&['B','C','G'].includes(n.answers[id])&&['B','C','G'].includes(value);
  // Only answers given after the edited one depend on it; earlier answers that led to it stay. A dependent with no answered instance is treated as later.
  const when=k=>{let t=null;n.history.forEach((x,i)=>{if(x.id===k&&x.state==='answered'){const v=x.answeredAt??i-1e9;if(t===null||v>t)t=v;}});return t;};
  const at=when(id),later=dep=>{const j=when(dep);return at===null||j===null||j>at;};
  for(const dep of sameTransferableRole?[]:(dependencies[id]||[]).filter(later)){delete n.answers[dep];delete n.contexts[dep];for(const h of n.history.filter(x=>x.id===dep))h.state='invalidated';}
 }
 n.answers[id]=structuredClone(value);n.revision++;return n;
}
export function present(session,q){
 const n=structuredClone(session),budget=budgetOf(q.id);
 if(budget==='core'&&!CORE.includes(q.id))throw Error('Unknown core question');
 const context=q.context||'standard';
 let h=n.history.find(x=>x.id===q.id&&(budget==='core'||x.context===context));
 if(!h){const c=counts(n.history);if(budget!=='core'&&c[budget]>=(budget==='adaptive'?4:2))throw Error('Question allowance exhausted');h={id:q.id,instanceId:q.id+':'+(n.history.length+1),context,budget,wordingVersion:VERSION,optionOrder:q.options?.map(x=>x.id)||[],state:'presented_unanswered'};n.history.push(h);}
 return {session:n,instance:h};
}
export function commit(session,q,value){
 const error=validateAnswer(q,value,session.answers);if(error)throw Error(error);
 let n=editAnswer(session,q.id,value);
 const p=present(n,q);n=p.session;
 const answered=n.history.find(x=>x.instanceId===p.instance.instanceId);answered.state='answered';answered.answeredAt=n.revision;
 n.contexts[q.id]=q.context||'standard';
 return n;
}
export function fromReference(c){
 const s=createSession();s.answers=structuredClone(c.answers);
 s.history=CORE.map((id,i)=>({id,instanceId:id+':'+(i+1),context:'standard',budget:'core',state:'answered',wordingVersion:c.wordingVersion||'specification-0.18'}));
 for(const step of c.steps){s.answers[step.id]=structuredClone(step.response_code);s.contexts[step.id]=step.instance_context;s.history.push({id:step.id,context:step.instance_context,instanceId:step.id+':'+(s.history.length+1),budget:budgetOf(step.id),state:'answered',wordingVersion:c.wordingVersion||'specification-0.18'});}
 return s;
}

